<template>
    <div>
        <div class="modal is-active" @click.stop="closeModal">
            <div class="modal-background"></div>
            <div class="modal-content">
                <div class="tile is-ancestor">
                    <div class="tile is-8 is-centered has-limited-width-600">
                        <article class="tile is-child is-12">
                            <div @click.stop>
                                <header class="modal-card-head is-block pb-0">
                                    <div class="level is-mobile">
                                        <div class="level-left">
                                            <div class="level-item">
                                                <a
                                                    class="level-item"
                                                    @click="closeModal"
                                                >
                                                    <span
                                                        class="icon is-medium"
                                                    >
                                                        <i
                                                            class="
                                                                mdi
                                                                mdi-24px
                                                                mdi-close
                                                            "
                                                        ></i>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            class="level-item has-text-centered"
                                        >
                                            <p
                                                class="
                                                    title
                                                    lb-alternative-font
                                                    is-size-4
                                                    has-text-weight-bold
                                                    is-long-title
                                                "
                                            >
                                                {{ content.title }}
                                            </p>
                                        </div>
                                        <div class="level-right">
                                            <div class="level-right">
                                                <div
                                                    :class="{
                                                        'has-text-primary':
                                                            content.liked,
                                                    }"
                                                    class="level-item"
                                                    @click="toggleLike"
                                                >
                                                    <p
                                                        class="
                                                            has-text-weight-bold
                                                        "
                                                    >
                                                        {{ content.likes || 0 }}
                                                    </p>
                                                    <span
                                                        class="icon is-medium"
                                                    >
                                                        <i
                                                            class="
                                                                mdi
                                                                mdi-18px
                                                                mdi-thumb-up
                                                            "
                                                            aria-hidden="true"
                                                        ></i>
                                                    </span>
                                                </div>
                                                <a
                                                    class="level-item"
                                                    @click="
                                                        showShareModal = true
                                                    "
                                                >
                                                    <span
                                                        class="icon is-medium"
                                                    >
                                                        <i
                                                            class="
                                                                mdi
                                                                mdi-24px
                                                                mdi-share-variant
                                                            "
                                                        ></i>
                                                    </span>
                                                </a>
                                                <div class="level-item">
                                                    <user-mini-profile
                                                        v-if="content.owner"
                                                        :user="content.owner"
                                                        :show-name="false"
                                                    />
                                                </div>
                                                <a
                                                    v-if="canEdit"
                                                    class="level-item"
                                                    @click="editObject"
                                                >
                                                    <span
                                                        class="icon is-medium"
                                                    >
                                                        <i
                                                            class="
                                                                mdi
                                                                mdi-24px
                                                                mdi-pencil
                                                            "
                                                        ></i>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                                <section class="modal-card-body pt-0">
                                    <hr />
                                    <ObjectGallery
                                        v-if="content.images"
                                        :images="content.images"
                                        :showing="true"
                                    />
                                    <object-card-tags
                                        v-if="content.tags"
                                        :tags="content.tags"
                                    />
                                    <p
                                        class="content has-text-black mb-0"
                                        v-html="content.description"
                                    />
                                    <ObjectVideo
                                        v-if="content.video"
                                        :video="content.video"
                                        class="pt-3"
                                    />
                                    <ObjectAudio
                                        v-if="content.audio"
                                        :audio="content.audio"
                                    />
                                    <ObjectEmbed
                                        v-if="content.embed"
                                        :embed="content.embed"
                                    />
                                    <ObjectStaticMap
                                        v-if="!locationIsEmpty && !isMap"
                                        :location="content.location"
                                    />
                                    <ObjectURL
                                        v-if="content.url"
                                        :url="content.url"
                                    />
                                    <ObjectFiles
                                        v-if="
                                            content.files &&
                                            content.files.length
                                        "
                                        :files="content.files"
                                    />
                                </section>
                                <object-card-comments
                                    v-if="isLoggedIn && canAddComment"
                                    :comments="content.comments"
                                    :object="content"
                                    :render-all="showAllComments"
                                    class="lb-modal-comments"
                                    @loadOldComments="showAllComments = true"
                                />
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
        <project-modal-share
            v-if="showShareModal"
            :content="content"
            @close="showShareModal = false"
        />
    </div>
</template>

<script>
import { likeObject } from '@/services/API';
import { isEmpty } from 'underscore';
import UserMiniProfile from '@/components/UserMiniProfile';
import AppModalView from '@/components/AppModalView';
import ObjectCardComments from '@/components/ObjectCardComments';
import ProjectModalShare from '@/components/ProjectModalShare';
import ObjectGallery from '@/components/ObjectGallery';
import ObjectVideo from '@/components/ObjectVideo';
import ObjectAudio from '@/components/ObjectAudio';
import ObjectEmbed from '@/components/ObjectEmbed';
import ObjectStaticMap from '@/components/ObjectStaticMap';
import ObjectFiles from '@/components/ObjectFiles';
import ObjectURL from '@/components/ObjectURL';
import ObjectCardTags from '@/components/ObjectCardTags';
export default {
    components: {
        UserMiniProfile,
        AppModalView,
        ObjectCardComments,
        ProjectModalShare,
        ObjectGallery,
        ObjectVideo,
        ObjectAudio,
        ObjectEmbed,
        ObjectStaticMap,
        ObjectFiles,
        ObjectURL,
        ObjectCardTags,
    },
    props: {
        objectId: { type: String, default: undefined },
    },
    data: function () {
        return { showShareModal: false, showAllComments: false };
    },
    computed: {
        content() {
            return this.$store.getters.itemById(this.objectId);
        },
        contentURL() {
            return window.location.href;
        },
        isMap() {
            return 'map' === this.$store.getters.project.mode;
        },
        locationIsEmpty() {
            return isEmpty(this.content.location);
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        canAddComment() {
            if (this.isLoggedIn && this.$store.getters.canCommentInObjects) {
                return true;
            }
            return false;
        },
        canEdit() {
            if (this.content.accessLevel) {
                return this.content.accessLevel != 'read';
            } else {
                return false;
            }
        },
    },
    methods: {
        closeModal() {
            this.$router.replace({
                name: this.$route.meta.embed ? 'embed-project' : 'project',
                params: { projectId: this.$store.getters.project._id },
                query: this.$route.query,
            });
        },
        editObject() {
            this.$router.replace({
                name: this.$route.meta.embed ? 'embed-project' : 'project',
                params: {
                    projectId: this.$store.getters.project._id,
                    edit: true,
                    object: this.$route.params.objectId,
                },
                query: this.$route.query,
            });
        },
        async toggleLike() {
            let likeResult = await likeObject(this.content._id);
            console.log({ likeResult });
        },
    },
};
</script>

<style scoped>
.modal-card-title {
    flex-shrink: 1;
}
.modal-card-body > * + * {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.modal-content {
    width: 100%;
    padding: 20px;
    overflow: auto;
}
.lb-modal-comments {
    max-height: 90vh;
}
.lb-card-comments {
    margin: auto;
}
.is-long-title {
    flex-grow: 1;
    width: 0;
}
.is-centered {
    margin: 0 auto;
}
.has-limited-width-600 {
    max-width: 600px;
}
</style>
